<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Wel">Welcome to Spooky Southern California!</p>
<p class="para1">What comes to mind when you think of Southern California? Perhaps you envision one of its many beautiful beaches or ocean piers. Or maybe the famous celebrities of Hollywood, the movie capital of the world. Or it could be the legendary filmmaker Walt Disney and his influential amusement park, Disneyland. The park in Anaheim has been one of Southern California’s most treasured institutions for nearly seventy years.</p>
<p class="para">While the ride at Disneyland suggests, “It’s a small world, after all,” there is so little that we know—or don’t know—about what happens when darkness descends on the sunny shores of the Pacific Coast. When ghosts, ghouls, and lost souls wander the boulevards looking to give anyone who’s <i>‘California dreamin’</i> a nightmare they’ll never forget.</p>
<p class="para">Southern California feels like a place where the sun never disappears behind the clouds, and happiness is just around every corner. But don’t be fooled! That facade is just as fragile as a Hollywood movie set. Because from San Diego to Hollywood and Santa Barbara to Death Valley, danger lurks in the shadows of Southern California, and there is plenty of haunting history to offer visitors who seek the supernatural.</p>
<p class="para">This sun-kissed part of the country has its fair share of dark history, a history that many people don’t know or don’t want to know. And around every corner, you’re likely to find spine-tingling tales of betrayals, murders, and tragedy that make it clear Southern California isn’t <i>always</i> the place where dreams come true. Very often it’s a land of lost and broken dreams turned into nightmares, where spirits and specters roam, looking for comfort, release, or revenge.</p>
<p class="para">Wherever you go in Southern California, ghosts are waiting for you. Are you ready to meet them? Throw on your sunglasses, and let’s begin our journey!</p>
<p class="image-center"><img alt="Image" src="images/P9.jpg"/></p>
<p class="image-center"><img alt="Image" src="images/P10.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Welcome_spooky.vue?fda3d18a